import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getCustomData } from '@global/selectors'

import './style.scss'

import Modal from '../../../../../../../../../../../../../../../components/Modals/CommonModal'
import { negativeEventsLoadEventDetail } from '../../../../../../actions'

export default function ({ onClose, docId, module, entId, block, level }) {
    const dispatch = useDispatch()
    const customData = useSelector((state) => getCustomData(state, module, block, entId))
    const eventDetailContent = customData?.eventsDetail?.[docId]?.content

    useEffect(() => {
        if (!eventDetailContent) {
            dispatch(negativeEventsLoadEventDetail({ module, block, entId, docId, level, eventDetailContent }))
        }
    }, [dispatch, module, block, entId, docId, eventDetailContent])

    if (!eventDetailContent) {
        return null
    }

    return (
        <Modal onClose={onClose}>
            <div className="insolvency-event-detail">{eventDetailContent}</div>
        </Modal>
    )
}
